export const common = {
  actions: {
    back: 'Back',
    bookmark: 'Bookmark',
    cancel: 'Cancel',
    clear: 'Clear',
    close: 'Close',
    copiedToClipboard: 'Copied to clipboard',
    copyToClipboard: 'Copy to clipboard',
    create: 'Create',
    delete: 'Delete',
    edit: 'Edit',
    moreInfo: 'More information',
    openMenu: 'Open menu',
    retry: 'Try again',
    revealPassword: 'Show password',
    save: 'Save',
    send: 'Send',
  },
  activities: {
    '1': {
      description: 'Graphic design, Illustration, Cartoon, Industrial design, Brand design, Art direction, 3D art, …',
      label: 'Visual communication',
    },
    '10': {
      description: 'Social media',
      label: 'Online content creation and storytelling',
    },
    '11': {
      label: 'Other',
    },
    '2': {
      description: 'Web design, UI/UX, …',
      label: 'Digital design',
    },
    '3': {
      description: 'Photography, post-production, …',
      label: 'Photography',
    },
    '4': {
      description: 'Videography, Video editing, Voice-over, Motion design, Sound design, …',
      label: 'Audiovisual',
    },
    '5': {
      description: 'Copywriting, Translation, Copy editing, …',
      label: 'Language and communication',
    },
    '6': {
      description: 'IT development, Web development, Game development, …',
      label: 'IT development',
    },
    '7': {
      description: 'Course, Workshop, …',
      label: 'Training',
    },
    '8': {
      description: 'Model, Presenter, Actor, …',
      label: 'Performing artist',
    },
    '9': {
      description: 'Styling, Food styling, Interior design, …',
      label: 'Styling & interior',
    },
  },
  add: 'Add',
  autoSave: 'Saving…',
  autoSaveLastSavedAt: {
    justNow: 'Just saved',
    timeAgo: '{{timeAgo}} saved',
  },
  blocker: {
    leave: 'Leave without saving',
    stay: 'Stay on page',
    title: 'Leave page',
  },
  breadcrumb: 'Breadcrumb',
  breadcrumbs: {
    details: 'Details',
    draft: 'Draft',
    home: 'Home',
  },
  colorPicker: {
    ariaLabel: 'Change the color theme. {{ colorTheme }} is active.',
    options: {
      'blue-orange': 'Blue-orange',
      'bordeaux-gray': 'Bordeaux-gray',
      'green-pink': 'Green-pink',
      'purple-yellow': 'Purple-yellow',
      'red-lightblue': 'Red-light blue',
    },
  },
  combobox: {
    removeChip: 'Remove {{label}}',
  },
  customAgreementOptionLabel: 'According to framework agreement',
  datatable: {
    all: 'all',
    deleteFilter: 'Remove {{filter}} filter',
    download: 'Download',
    filters: 'Filters',
    loadingData: 'Loading data…',
    noData: 'No results found.',
    search: 'Search',
    selection: {
      amountSelected: '{{amount}} selected.',
      removeSelection: 'Remove selection',
      selectAll: 'Select all',
      selectRow: 'Select row',
    },
    show: 'Show',
    showFilters: 'Show filters',
    showResults: 'Show results',
    sortBy: 'Sort by {{column}}',
  },
  draft: {
    defaultTitle: 'No title',
    deleteModal: {
      description: 'Are you sure you want to delete the draft?',
      submit: 'Delete draft',
      title: 'Delete draft',
    },
  },
  error: 'Something went wrong. Contact service@creativeshelter.be if the problem persists.',
  errors: {
    contactSupport: 'Contact <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> if the problem persists.',
    fetchError: 'No connection to the server. Check your connection and try again.',
    global: {
      text: 'Contact <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> if the problem persists.',
      title: 'Something went wrong',
    },
    httpErrorWithLink:
      'Something went wrong. Contact <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> if the problem persists.',
    tooManyRequests: 'Overload! Too many attempts. Please wait a moment and try again.',
    unknown: 'An unexpected error occurred.',
  },
  export: 'Export',
  fields: {
    datePicker: {
      label: 'Date',
      openCalendar: 'Open calendar',
    },
    numberInput: {
      decrement: 'Decrease value',
      increment: 'Increase value',
    },
    prefixAriaLabel: 'This field has the prefix “{{prefix}}”. You don’t need to fill it in yourself.',
    select: {
      multipleValuesAriaLabel: '{{ count }} items selected',
    },
    suffixAriaLabel: 'This field has the suffix “{{suffix}}”. You don’t need to fill it in yourself.',
  },
  fileUpload: {
    avatarPrompt: '<browse>Click to choose a photo</browse> or drag your photo here',
    dropTarget: 'Drop your files here',
    error: 'File upload failed.',
    filePrompt: '<browse>Click to add a file</browse> or drag your file here',
    maxSize: 'max. {{max}} MB',
    rejectedSize: '{{name}} is larger than {{max}} MB.',
    rejectedType: '{{name}} has a file type that isn’t supported.',
    remove: 'Remove file',
    retry: 'Try again',
    unnamedFile: 'File',
    uploading: 'Uploading',
    view: 'View file',
  },
  greetings: {
    common: 'Hi',
    evening: 'Good evening',
    morning: 'Good morning',
    noon: 'Good afternoon',
  },
  impersonationBanner: {
    description: 'Actions you perform here are recorded as if this user were doing them themselves.',
    stop: 'Stop impersonation',
    title: 'You’re viewing the account of {{name}}',
  },
  infiniteScroll: {
    scrollToTop: 'Back to top',
    showMore: 'Show more',
  },
  languageSelector: 'Open language selector, {{value}} is selected',
  languages: {
    en: 'English',
    fr: 'French',
    nl: 'Dutch',
  },
  languagesShort: {
    en: 'EN',
    fr: 'FR',
    nl: 'NL',
  },
  listbox: {
    noOptions: 'No results',
    noResults: 'No results',
    search: 'Search…',
  },
  loading: 'Loading data…',
  maintenance: {
    description: 'We’re doing some work on the platform, but we’ll be back soon so you won’t have to miss us for long.',
    title: 'Away for a moment, but back soon!',
  },
  menu: {
    documents: 'Documents',
    invitations: 'Invitations',
    logout: 'Log out',
    pricing: 'Your fee',
    settings: 'Settings',
  },
  models: {
    quotation: 'Quotation',
  },
  navigation: {
    main: 'Main navigation',
    menu: 'Menu',
    shortcuts: 'Quick navigation',
  },
  ok: 'OK',
  optionalInput: '(optional)',
  or: 'or',
  pagination: {
    label: 'Page navigation',
    next: 'Next page',
    pageSize: 'Results per page',
    previous: 'Previous page',
  },
  pdfPreview: {
    download: 'Download PDF',
    fallback: 'Your browser can’t display this PDF.',
  },
  placeholders: {
    file: 'Choose your file',
    select: 'Select',
  },
  richText: {
    errors: {
      render: 'Something went wrong while loading the content.',
    },
    linkModal: {
      editTitle: 'Edit the link',
      label: 'Link',
      textLabel: 'Text',
      title: 'Enter a link',
    },
    toolbar: {
      bold: 'Bold',
      bulletList: 'Bulleted list',
      editLink: 'Edit link',
      groups: {
        formatting: 'Text formatting',
        history: 'History',
        lists: 'Lists',
        shortcodes: 'Add shortcode',
      },
      italic: 'Italic',
      link: 'Add link',
      orderedList: 'Numbered list',
      redo: 'Redo',
      shortcodes: 'Add shortcode',
      underline: 'Underline',
      undo: 'Undo',
      unlink: 'Remove link',
    },
  },
  save: 'Save',
  saved: 'Saved',
  send: 'Send',
  sidebar: {
    clients: 'Clients',
    community: 'Network',
    dashboard: 'Dashboard',
    expandMenu: 'Expand menu',
    forum: 'Forum',
    groupInvoicing: 'Invoicing',
    groupSocial: 'Community',
    help: 'Help',
    invite: 'Invite friends',
    invoices: 'Invoices',
    jobPosts: 'Assignments',
    minimalizeMenu: 'Collapse menu',
    more: 'More',
    products: 'Products',
    quotations: 'Quotations',
  },
  status: {
    completed: 'Completed',
    upcoming: 'To do',
  },
  timeline: {
    ariaLabel: 'Timeline',
  },
  topbar: {
    activePremiumForFree_one: 'Last day of free invoicing',
    activePremiumForFree_other: '{{count}} more days of free invoicing',
    dropdown: {
      commission: 'Your fee',
      documents: 'Documents',
      invitations: 'Invitations',
      logout: 'Log out',
      settings: 'Settings',
    },
  },
};
